import { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/seo";

export default function PolicyPage({ slug }) {
  const [page, setPage] = useState(null);
  const [failed, setFailed] = useState(false);

  useSeo({
    title: page?.title ? `${page.title} | Soonyoung` : "Soonyoung — Policy",
    description: page?.meta_description,
    path: `/${slug}`,
  });

  useEffect(() => {
    setPage(null);
    setFailed(false);
    api.get(`/ecom/pages/${slug}`)
      .then((r) => setPage(r.data))
      .catch(() => setFailed(true));
  }, [slug]);

  const comingSoon = failed || (page && !page.html);

  return (
    <section data-testid={`policy-page-${slug}`} className="mx-auto max-w-3xl px-4 pb-24 pt-28 sm:px-6 sm:pt-36">
      {!page && !failed ? (
        <div className="space-y-4" data-testid="policy-loading">
          <div className="h-10 w-2/3 animate-pulse rounded bg-moss" />
          <div className="h-4 w-full animate-pulse rounded bg-moss" />
          <div className="h-4 w-5/6 animate-pulse rounded bg-moss" />
          <div className="h-4 w-4/6 animate-pulse rounded bg-moss" />
        </div>
      ) : comingSoon ? (
        <div className="flex flex-col items-center rounded-3xl border border-dashed border-champagne/60 py-24 text-center" data-testid="policy-coming-soon">
          <FileText className="h-10 w-10 text-gold" />
          <h1 className="mt-4 font-display text-3xl text-cream">Content coming soon</h1>
          <p className="mt-2 max-w-sm text-sm text-sage">
            Our team is finalising this page. It will appear here automatically the moment HQ publishes it.
          </p>
        </div>
      ) : (
        <article>
          <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold">Soonyoung · Legal</p>
          <h1 data-testid="policy-title" className="mt-3 font-display text-3xl leading-tight tracking-tight text-cream sm:text-5xl">
            {page.title}
          </h1>
          <p data-testid="policy-updated-at" className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-fern">
            Last updated {new Date(page.updated_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}
          </p>
          <div className="mt-8 h-px bg-champagne/40" />
          <div data-testid="policy-body" className="cms-prose mt-8" dangerouslySetInnerHTML={{ __html: page.html }} />
          <div className="mt-12 rounded-2xl border border-champagne/40 bg-pine p-5 text-xs text-sage">
            Questions about this policy? Write to us via the <a href="/contact" className="text-gold underline underline-offset-4">contact page</a>.
          </div>
        </article>
      )}
    </section>
  );
}
